<template>
  <div class="mb-2">
    <div
      v-if="period.isTooEarly()"
      v-safe-html="$t('features.long_term.summary.early')"
    />
    <div
      v-else-if="period.isAhead()"
      v-safe-html="$t('features.long_term.summary.ahead')"
    />
    <div
      v-else-if="period.isFarAhead()"
      v-safe-html="$t('features.long_term.summary.far_ahead')"
    />
    <div
      v-else-if="period.isBehind()"
      v-safe-html="$t('features.long_term.summary.behind')"
    />
    <div
      v-else-if="period.isBehindSeverely()"
      v-safe-html="$t('features.long_term.summary.severely_behind')"
    />
    <div v-else-if="period.isFinished()">This period has finished.</div>
    <div
      v-else-if="period.isUninitialized()"
      v-safe-html="$t('features.long_term.summary.not_configured')"
    ></div>
    <Message v-else severity="warn">
      {{ $t('features.long_term.summary.unknown') }}
      <br />
      <strong>{{ period.getSummaryFlag() }}</strong>
    </Message>
  </div>
</template>

<script lang="ts">
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';

export default {
  name: 'LongTermPeriodSummary',
  props: {
    period: { type: YieldPromiseStatus, required: true },
  },
};
</script>

<style scoped></style>
